/** Event Platform stores all event timestamps in UTC; display/filter Castagnata days in Europe/Rome. */
const ZONE='Europe/Rome';

export function eventToday():string{
  const parts=new Intl.DateTimeFormat('en-GB',{timeZone:ZONE,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
  const field=(key:string)=>parts.find(p=>p.type===key)?.value??'';
  return `${field('year')}-${field('month')}-${field('day')}`;
}
function localStartUtc(ymd:string):string{
  if(!/^\d{4}-\d{2}-\d{2}$/.test(ymd))throw new Error('Data non valida');
  const [year,month,day]=ymd.split('-').map(Number);
  const utcMidnight=new Date(Date.UTC(year,month-1,day));
  if(utcMidnight.toISOString().slice(0,10)!==ymd)throw new Error('Data non valida');
  const name=new Intl.DateTimeFormat('en-US',{timeZone:ZONE,timeZoneName:'shortOffset'}).formatToParts(utcMidnight).find(p=>p.type==='timeZoneName')?.value??'';
  const offset=name.match(/^GMT([+-])(\d{1,2})(?::(\d{2}))?$/);
  if(!offset)throw new Error('Fuso orario Europa/Roma non disponibile');
  const mins=(offset[1]==='+'?1:-1)*(Number(offset[2])*60+Number(offset[3]??0));
  return new Date(utcMidnight.getTime()-mins*60_000).toISOString();
}
export function eventDayUtcBounds(day:string):{from:string;until:string}{
  if(!/^\d{4}-\d{2}-\d{2}$/.test(day))throw new Error('Data non valida');
  const [y,m,d]=day.split('-').map(Number);
  const next=new Date(Date.UTC(y,m-1,d+1)).toISOString().slice(0,10);
  return {from:localStartUtc(day),until:localStartUtc(next)};
}
